import React from "react";

function Contact() {
  return (
    <div
      className="container d-flex justify-content-center"
      style={{
        marginTop: "5rem",
        marginBottom: "5rem",
      }}
    >
      <div
        className="bg-white p-3 p-md-5 round-x2 shad-x2"
        style={{ maxWidth: "900px", width: "100%" }}
      >
        <div className="text-center">
          <h2 className="work-h2">
            Let’s{" "}
            <span className="d-inline-block border-reddish pb-1">Con</span>
            nect!.
          </h2>
          <div className="d-flex gap-4 my-5 mb-md-0 align-items-center justify-content-center px-5">
            <div className="d-flex align-items-center">
              <a
                href="mailto:eskaychinaza8@gmail.com?subject=Inquiry&body=Hi,%20I%20have%20a%20question%20about..."
                className="ms-2 text-dark text-decoration-none"
              >
                <img src="/image/envelope.png" alt="email" width="25px" />
              </a>
            </div>
            <div className="d-flex align-items-center mt-md-0">
              <a
                href="http://linkedin.com/in/chinaza-eskay-108443233"
                target="_blank"
                rel="noopener noreferrer"
                className="ms-2 text-dark text-decoration-none"
              >
                <img src="/image/linkedin-black.png" alt="phone" width="25px" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
